import { Store } from 'redux';
import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { RootState } from './redux/reducers/rootReducer';

export const setupLanguageInterceptor = (axiosInstance: AxiosInstance, store: Store<RootState>): number => {
  const requestInterceptorId = axiosInstance.interceptors.request.use(
    (config: AxiosRequestConfig): AxiosRequestConfig => {
      try {
        
        const state = store.getState();
        const currentLanguage = state?.currentLanguage;
        const currentCountry = state?.currentCountry;

        if (
          currentLanguage &&
          currentCountry &&
          typeof currentLanguage === 'string' &&
          typeof currentCountry === 'string' &&
          !config.headers?.['Accept-Language']
        ) {
          // Combine language + country: 'en' + 'US' = 'en-US'
          const locale = `${currentLanguage}-${currentCountry}`;
          
          return {
            ...config,
            headers: {
              ...config.headers,
              'Accept-Language': locale,
            },
          };
        }

        return config;
      } catch (error) {
        console.error('Error in language interceptor:', error);
        return config;
      }
    },
    (error: unknown) => {
      console.error('Request interceptor error:', error);
      return Promise.reject(error);
    }
  );

  return requestInterceptorId;
};
